<template>
    <div class="step2-location">
        <div :class="['field', { 'has-error': store.validationErrors.country }]">
            <label class="label">{{ translate("manage_academy.country") }}</label>
            <CountrySelect v-model="store.country" />
            <p v-if="store.validationErrors.country" class="help is-danger">
                {{ store.validationErrors.country[0] }}
            </p>
        </div>

        <div :class="['field', { 'has-error': store.validationErrors.place }]">
            <label class="label">{{ translate("page.admin_edit_event.place") }}</label>
            <div class="control">
                <input
                    v-model="store.place"
                    class="input"
                    type="text"
                    maxlength="100"
                    :placeholder="translate('wizard.step2.place_placeholder')"
                />
            </div>
            <p v-if="store.validationErrors.place" class="help is-danger">
                {{ store.validationErrors.place[0] }}
            </p>
        </div>

        <div class="field">
            <label class="label">{{ translate("wizard.step2.contact_heading") }}</label>
            <p class="help mb-3">{{ translate("wizard.step2.contact_helper") }}</p>
            <div :class="['field', { 'has-error': store.validationErrors.contactEmail }]">
                <label class="label is-small has-text-grey-light">{{ translate("common.email") }}</label>
                <div class="control">
                    <input v-model="store.contactEmail" class="input" type="email" maxlength="100" />
                </div>
                <p v-if="store.validationErrors.contactEmail" class="help is-danger">
                    {{ store.validationErrors.contactEmail[0] }}
                </p>
            </div>
            <div class="field mb-0">
                <label class="label is-small has-text-grey-light">{{ translate("form.phone") }}</label>
                <div class="control">
                    <PhoneNumberInput v-model="store.contactPhone" />
                </div>
            </div>
            <p v-if="store.validationErrors.contactInfo" class="help is-danger mt-2">
                {{ store.validationErrors.contactInfo[0] }}
            </p>
        </div>

        <div class="field mt-5">
            <div class="buttons">
                <button class="button" @click="emit('back')"><i class="fas fa-arrow-left mr-2"></i> {{ translate("common.back") }}</button>
                <button class="button is-primary is-flex-grow-1" data-testid="wizard-continue" @click="onSubmit">
                    {{ translate("common.continue") }} <i class="fas fa-arrow-right ml-2"></i>
                </button>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import CountrySelect from "../../../Common/CountrySelect.vue";
    import PhoneNumberInput from "../../../Common/PhoneNumberInput.vue";
    import { translate } from "../../../Common/translations";
    import { useWizardStore } from "../wizardStore";
    import { validateStep2 } from "../wizardValidation";

    const emit = defineEmits<{
        submit: [];
        back: [];
    }>();

    const store = useWizardStore();

    function onSubmit() {
        const errors = validateStep2({
            country: store.country,
            place: store.place,
            contactEmail: store.contactEmail,
            contactPhone: store.contactPhone,
        });
        const rest = { ...store.validationErrors };
        delete rest.country;
        delete rest.place;
        delete rest.contactEmail;
        delete rest.contactInfo;
        store.validationErrors = Object.keys(errors).length > 0 ? { ...rest, ...errors } : rest;
        if (Object.keys(errors).length > 0) {
            return;
        }
        emit("submit");
    }
</script>
